import React from "react";

export default function nth0WithSup(n: number) {
	const nMod100 = n % 100;
	const nMod10 = n % 10;

	return (
		<div>
			{n + 1}
			<sup>
				{
					nMod100 > 10 && nMod100 < 20 ? "th" :
					nMod10 === 0 ? "st" :
					nMod10 === 1 ? "nd" :
					nMod10 === 2 ? "rd" : "th"
				}
			</sup>
		</div>
	);
}